import { HumanMaleBoardIcon } from './HumanMaleBoardIcon';

/**
 * author: Michael Richins
 * id A989F68B-23B9-4B50-BE4D-E3DF6E9420C9
 * name human-male-board
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/human-male-board.svg
 * tags
 * - People / Family 
 */
export const CollegeIcon = HumanMaleBoardIcon;
export default CollegeIcon